<template>
  <div>
    <form-group :validations="validation">
      <div slot-scope="{ errors, invalid }">
        <input
            type="file"
            id="select_single_image"
            name="select_single_image"
            :accept="acceptAttribute"
            class="d-none"
            @input="onSingleFileChange">
        <label for="select_single_image" class="single-image-picker" :class="{ 'single-image-picker--empty': !hasPreview, invalid }">
          <template v-if="!hasPreview">
            <b-icon icon="image" class="single-image-picker__icon"/>
            <span class="single-image-picker__text">انتخاب تصویر</span>
          </template>
          <img v-else :src="previewController()" class="single-image bg-white border rounded" :class="{ invalid }" alt="">
        </label>

        <form-errors-manager :errors="errors"/>
      </div>
    </form-group>
  </div>
</template>
<script>
import FormGroup from "../../../validator/FormGroup.vue";
import FormErrorsManager from "../../../validator/FormErrorsManager.vue";
import {defaultProductImage} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product'

export default {
  name: "SingleImage",
  props: {
    mainImage: {},
    mainPreview: {},
    validation: {},
    allowedExtensions: {
      type: Array,
      default: null
    }
  },
  components: {FormGroup, FormErrorsManager},
  data() {
    return {
      mainPicProps: {
        blank: true,
        blankColor: "#fff",
        class: "m1",
      },
      preview: '',
      status: 1, // create mode
      defaultProductImage
    };
  },
  model: {
    prop: 'mainImage',
    event: 'input'
  },
  computed: {
    hasPreview() {
      return !!this.previewController()
    },
    acceptAttribute() {
      if (!this.allowedExtensions || !this.allowedExtensions.length) {
        return 'image/*'
      }
      return this.allowedExtensions.map(ext => `.${ext}`).join(',')
    }
  },
  methods: {
    getExtension(file) {
      const name = (file && file.name) ? file.name : ''
      const parts = name.split('.')
      return parts.length > 1 ? parts[parts.length - 1] : ''
    },
    isAllowed(file) {
      if (!this.allowedExtensions || !this.allowedExtensions.length) {
        return true
      }
      return this.allowedExtensions.indexOf(this.getExtension(file)) > -1
    },
    onSingleFileChange(e) {
      const file = e.target.files[0];
      if (!file) {
        return
      }
      if (!this.isAllowed(file)) {
        this.$emit('invalid-image', {file, extension: this.getExtension(file)})
        e.target.value = ''
        return
      }
      this.mainPicProps.blank = false;
      this.status = 0
      this.preview = URL.createObjectURL(file);
      this.$emit('input', file)
    },
    previewController() {
      if (this.mainPreview !== "" && this.status === 1) {
        this.preview = this.mainPreview;
        return this.preview
      }
      return this.preview
    }
  }
};
</script>

<style scoped>
.single-image-picker {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  cursor: pointer;
}

.single-image-picker--empty {
  flex-direction: column;
  gap: 0.35rem;
  width: 120px;
  height: 120px;
  border: 1.5px dashed rgba(30, 30, 30, 0.18);
  border-radius: 16px;
  background: #f7f7f8;
  color: #6b6b6b;
  transition: border-color 0.2s ease, color 0.2s ease, background 0.2s ease;
}

.single-image-picker--empty:hover {
  border-color: #eb3d60;
  color: #eb3d60;
  background: rgba(235, 61, 96, 0.04);
}

.single-image-picker__icon {
  font-size: 1.75rem;
}

.single-image-picker__text {
  font-size: 0.8rem;
  font-weight: 700;
}

.single-image {
  object-fit: cover;
  width: 120px;
  height: 120px;
}
</style>
